<ct-lib-modal
  [label]="'jobboard.platform.settings.tfa.add-modal.title' | transloco"
  [footer]="addMethodModalFooter"
  (onOpen)="onModalOpen()"
  (onCloseEnd)="onModalCloseEnd()"
  [small]="true"
  #addMethodModal
>
  @if (!qrLoaded) {
    <ct-lib-info-banner class="tfa-info">{{
      'jobboard.platform.settings.tfa.add-modal.info' | transloco
    }}</ct-lib-info-banner>
    <form [formGroup]="addMethodForm">
      <div class="row mt-3">
        <div
          class="col-12 form-group form-floating"
          [class.invalid]="addMethodFormSubmitAttempt && name.invalid"
        >
          <input
            type="text"
            formControlName="name"
            class="form-control"
            id="tfaName"
            [placeholder]="'jobboard.platform.settings.tfa.add-modal.name' | transloco"
            (keyup.enter)="onContinue()"
          />
          <label for="tfaName">{{
            'jobboard.platform.settings.tfa.add-modal.name' | transloco
          }}</label>
        </div>
      </div>
    </form>
  } @else {
    <form [formGroup]="addMethodForm">
      <div class="row">
        <div class="col-12 form-group form-floating">
          <input
            type="text"
            formControlName="name"
            class="form-control"
            id="tfaNameReadonly"
            readonly
            [placeholder]="'jobboard.platform.settings.tfa.add-modal.name' | transloco"
          />
          <label for="tfaNameReadonly">{{
            'jobboard.platform.settings.tfa.add-modal.name' | transloco
          }}</label>
        </div>
      </div>
    </form>
    <span [innerHTML]="'jobboard.platform.settings.tfa.add-modal.qr-info' | transloco"></span>
    <div class="qr-code-wrapper">
      <img [src]="tfaQRCodeImage" [alt]="'jobboard.platform.settings.tfa.add-modal.qr-alt' | transloco" />
      <span>
        {{ 'jobboard.platform.settings.tfa.add-modal.qr-manual' | transloco }}<br />
        <b>{{ tfaQRCode }}</b>
      </span>
    </div>
    <span [innerHTML]="'jobboard.platform.settings.tfa.add-modal.code-info' | transloco"></span>
    <div class="tfa-input-wrapper">
      <app-platform-tfa-input
        [autoSubmit]="true"
        (submit)="onTFASubmit($event)"
        #tfaInput
      ></app-platform-tfa-input>
    </div>
  }
</ct-lib-modal>
<ng-template #addMethodModalFooter>
  <app-button variant="white-grey" (click)="newMethodModal().close()">
    {{ 'jobboard.platform.settings.tfa.add-modal.cancel' | transloco }}
  </app-button>
  @if (!qrLoaded) {
    <app-button [loading]="loadingQr" (click)="onContinue()">
      {{ 'jobboard.platform.settings.tfa.add-modal.next' | transloco }}
    </app-button>
  }
</ng-template>
